import React from "react";
import truck from "../../assets/images/estimate/truck.png";
import { useHistory } from "react-router-dom";
import navigationsLinks from "../../constants/navigation_links";
import { useSelector } from "react-redux";

export default function ProgressBar(props) {
  const stepProgressData = JSON.parse(
    sessionStorage.getItem("stepProgressData")
  );
  const history = useHistory();
  // var progressUpdate = null;
  if (stepProgressData) {
    console.log("Step progress data", stepProgressData);
    // progressUpdate = stepProgressData;
  }
  const progressInfo = useSelector((state) => state.progressInfo);
  /* Each Index value represets the estimate flow page.
   * [MoveDetails,PropertyInfo,inventory,Summary]
   */
  let truckVisiblity = [0, 0, 0, 0];
  let progressLine = [0, 0, 0];
  let currentPage = props.currentPage;

  if (currentPage === "moveDetails") {
    truckVisiblity[0] = 1; //movedetails truck visible
    progressLine = [0, 0, 0, 0];
  }

  if (currentPage === "propertyInfo") {
    truckVisiblity[1] = 1; //propertyInfo truck visible
    progressLine = [1, 0, 0, 0];
  }

  if (currentPage === "inventory") {
    truckVisiblity[2] = 1; //inventory truck visible
    progressLine = [1, 1, 0, 0];
  }

  if (currentPage === "summary") {
    truckVisiblity[3] = 1; //summary truck visible
    progressLine = [1, 1, 1, 1];
  }
  const checkValidTransfer = (gotoPage) => {
    // debugger;
    if (currentPage === "moveDetails") {
      // can't go to inventory or summary
      // other case
      if (gotoPage === navigationsLinks.move_details_page) {
        return false;
      }

      if (gotoPage === navigationsLinks.inventory_page) {
        if (progressInfo.step1 === 1 && progressInfo.step2 === 1) {
          return true;
        }
        return false;
      }
      if (gotoPage === navigationsLinks.summary_page) {
        if (
          progressInfo.step1 === 1 &&
          progressInfo.step2 === 1 &&
          progressInfo.step3 === 1
        ) {
          return true;
        }
        return false;
      }

      return true;
    }
    if (currentPage === "propertyInfo") {
      // can only goto inventory or moveDetails
      //can't go to summary
      if (gotoPage === navigationsLinks.property_info_page) {
        return false;
      }

      if (gotoPage === navigationsLinks.summary_page) {
        if (
          progressInfo.step1 === 1 &&
          progressInfo.step2 === 1 &&
          progressInfo.step3 === 1
        ) {
          return true;
        }
        return false;
      }
      return true;
    }

    if (currentPage === "inventory") {
      //can only goto summary, movedetails and inventory
      if (gotoPage === navigationsLinks.inventory_page) {
        return false;
      }
      if (gotoPage === navigationsLinks.summary_page) {
        if (progressInfo.step1 === 1 && progressInfo.step2 === 1) {
          return true;
        }
        return false;
      }
      return true;
    }

    if (currentPage === "summary") {
      if (gotoPage === navigationsLinks.summary_page) {
        return false;
      }
    }
    return true;
    //check gotopage with step progress.
  };
  const handleProgressBarSelection = (params) => {
    const { gotoPage } = params;

    const canGoToPage = checkValidTransfer(gotoPage);
    if (!canGoToPage) {
      return;
    }
    if (currentPage === "moveDetails") {
      props.referenceToSubmit({ gotoPage: gotoPage });
      return;
    }
    if (currentPage === "propertyInfo") {
      if (progressInfo.step1 === 1) {
        props.referenceToSubmit({ gotoPage: gotoPage });
      }
      return;
    }
    if (currentPage === "inventory") {
      if (progressInfo.step1 === 1 && progressInfo.step2 === 1) {
        props.referenceToSubmit({ gotoPage: gotoPage });
      }
      return;
    }
    if (currentPage === "summary") {
      if (
        progressInfo.step1 === 1 &&
        progressInfo.step2 === 1 &&
        progressInfo.step3 === 1
      ) {
        props.referenceToSubmit({ gotoPage: gotoPage });
      }
      return;
    }
    // if (currentPage === "summary") {
    //   if (
    //     progressInfo.step1 === 1 &&
    //     progressInfo.step2 === 1 &&
    //     progressInfo.step3 === 1
    //   ) {
    //     history.push(gotoPage);
    //   }
    // }
    history.push(gotoPage);
  };
  const JSX = (
    <div className="progress-bar-container">
      <ul className="progress-steps">
        <li className="step-item">
          <span
            className={
              "progress-link step" + (progressLine[0] === 1 ? " active" : "")
            }
            onClick={() => {
              handleProgressBarSelection({
                gotoPage: navigationsLinks["move_details_page"],
              });
            }}
          >
            Plan your <br /> move
          </span>
          {/* <Link
            to={navigationsLinks["move_details_page"]}
            // onClick={(e) => {  handleNavigationAndFormSubmission(e,'/Estimate')}}
            className={
              "progress-link step" + (progressLine[0] === 1 ? " active" : "")
            }
            id="step1"
          >
            Plan your <br /> move
          </Link> */}
          <img
            src={truck}
            className={
              "img-fluid" + (truckVisiblity[0] === 0 ? " invisible" : "")
            }
            alt=""
          />
        </li>
        <li className="step-item">
          {/* <Link
            to={navigationsLinks["property_info_page"]}
            className={
              "progress-link step" + (progressLine[1] === 1 ? " active" : "")
            }
            // onClick={(e) => {  handleNavigationAndFormSubmission(e,'/propertyInfo')}}
            id="step2"
          >
            Enter your <br /> floor info
            <img
              src={truck}
              className={
                "img-fluid" + (truckVisiblity[1] === 0 ? " invisible" : "")
              }
              alt=""
            />
          
          </Link> */}
          <img
            src={truck}
            className={
              "img-fluid" + (truckVisiblity[1] === 0 ? " invisible" : "")
            }
            alt=""
          />
          <span
            onClick={() => {
              handleProgressBarSelection({
                gotoPage: navigationsLinks["property_info_page"],
              });
            }}
            className={
              "progress-link step" + (progressLine[1] === 1 ? " active" : "")
            }
            // onClick={(e) => {  handleNavigationAndFormSubmission(e,'/propertyInfo')}}
            id="step2"
          >
            Enter your <br /> floor info
          </span>
        </li>
        <li className="step-item">
          {/* <Link
            to={navigationsLinks["inventory_page"]}
            className={
              "progress-link step" + (progressLine[2] === 1 ? " active" : "")
            }
            // onClick={(e) => {  handleNavigationAndFormSubmission(e,'/Inventory')}}
            id="step3"
          >
            Add your <br /> inventory
            <img
              src={truck}
              className={
                "img-fluid" + (truckVisiblity[2] === 0 ? " invisible" : "")
              }
              alt=""
            />
          </Link> */}
          <img
            src={truck}
            className={
              "img-fluid" + (truckVisiblity[2] === 0 ? " invisible" : "")
            }
            alt=""
          />
          <span
            onClick={() => {
              handleProgressBarSelection({
                gotoPage: navigationsLinks["inventory_page"],
              });
            }}
            className={
              "progress-link step" + (progressLine[2] === 1 ? " active" : "")
            }
            // onClick={(e) => {  handleNavigationAndFormSubmission(e,'/Inventory')}}
            id="step3"
          >
            Add your <br /> inventory
          </span>
        </li>
        <li className="step-item">
          {/* <Link
            to={navigationsLinks["summary_page"]}
            // onClick={(e) => {  handleNavigationAndFormSubmission(e,'/summary')}}
            className={
              "step last-step progress-link" +
              (progressLine[3] === 1 ? " active" : "")
            }
            id="step4"
          >
            Your move <br /> summary
            <img
              src={truck}
              className={
                "img-fluid" + (truckVisiblity[3] === 0 ? " invisible" : "")
              }
              alt=""
            />
          </Link> */}
          <img
            src={truck}
            className={
              "img-fluid" + (truckVisiblity[3] === 0 ? " invisible" : "")
            }
            alt=""
          />
          <span
            onClick={() => {
              handleProgressBarSelection({
                gotoPage: navigationsLinks["summary_page"],
              });
            }}
            // onClick={(e) => {  handleNavigationAndFormSubmission(e,'/summary')}}
            className={
              "step last-step progress-link" +
              (progressLine[3] === 1 ? " active" : "")
            }
            id="step4"
          >
            Your move <br /> summary
          </span>
        </li>
      </ul>
    </div>
  );
  return JSX;
}
